module.exports = __webpack_public_path__ + "static/media/insect(8).80a9ea86.PNG";